const LocalStorageService = {
    set,
    get,
    setObject,
    getObject,
    clear,
    remove
};
function set(key, value) {
    localStorage[key] = value;
    return localStorage[key];
}
function get(key, defaultValue) {
    return localStorage[key] || defaultValue;
}
function setObject(key, value) {
    localStorage[key] = JSON.stringify(value);
    return localStorage[key];
}

function getObject(key, value) {
    return JSON.parse(localStorage[key] || "{}");
}

function clear() {
    // Preserve notes drafts before clearing
    const preservedData = {};
    const keysToPreserve = [];
    
    // Find all keys that should be preserved (notes drafts)
    for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith('notes_draft_')) {
            keysToPreserve.push(key);
            preservedData[key] = localStorage.getItem(key);
        }
    }
    
    
    // Clear all localStorage
    localStorage.clear();
    
    // Restore preserved notes drafts
    for (const key of keysToPreserve) {
        if (preservedData[key]) {
            localStorage.setItem(key, preservedData[key]);
        }
    }
    
    return true;
}

function remove(key) {
    return localStorage.removeItem(key);
}

export default LocalStorageService;
